export default {
  "Drag and drop files here, or click to select the files to download.": "",
  "Select files": "",
  "Maximum upload file size: 8MB.": "",
  "Add a logo": "",
  "Apply a mask": "",
  "Apply a mask to your medias": "",
  "Apply a logo to your medias": "",
  Apply: "",
  Cancel: "",
  "Mask informations": "",
  Title: "",
  Description: "",
  "Uploaded at": "",
  "File type": "",
  "File size": "",
  Dimensions: "",
  "Select or import your mask": "",
  "Select or import your logo": "",
  "Select size": "",
  Small: "",
  Medium: "",
  Large: "",
  "eXtra Large": "",
  "Select position": ""
};



// WEBPACK FOOTER //
// ./src/i18n/en.js